import config from "devextreme/core/config";
import { licenseKey } from './devextreme-license.ts';
 
const LicenseCheckComponent = () => {
    if (typeof window !== "undefined") {
        config({
            defaultCurrency: 'MXN'
        });

        config({ licenseKey });
    }
    return null;
};
 
export default LicenseCheckComponent;